import React from 'react';
import { Container } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { InbodyKeysModal } from './containers/InbodyKeysModal/InbodyKeysModal';
import { InbodyKeysTable } from './containers/InbodyKeysTable/InbodyKeysTable';
import { InbodyKeysPageTitle } from './components/InbodyKeysPageTitle/InbodyKeysPageTitle';

const NgzInbodyKeys = () => {
  return (
    <Container>
      <InbodyKeysPageTitle />
      <InbodyKeysTable />
      <InbodyKeysModal />
    </Container>
  );
};

angularizeWithProviders(NgzInbodyKeys, 'ngzInbodyKeys', {});

export { NgzInbodyKeys };
